<div class="page-container">
  <div class="controls">
    <div class="filters">
      @for (statusType of statuses; track statusType) {
        <a class="poll-status-selector" href="javascript:;"
          [class.active]="status == statusType" (click)="switchStatus(statusType)">
          {{humanizeStatus(statusType)}}
        </a>
      }
    </div>
    @if (isStaff) {
      <a mat-raised-button color="primary" routerLink="/polls/new">
        <mat-icon>add</mat-icon>
        New
      </a>
    }
  </div>

  @if (hasDrafts) {
    <h1>Draft Polls</h1>
    <p>The following polls are drafted and not yet published. These are only shown to TYT staff.</p>
    <ng-container *ngTemplateOutlet="pollList; context: { polls: draftPolls }"></ng-container>
    <br />
  }

  @if (!hasDrafts || publishedPolls?.length > 1) {
    @if (hasDrafts) {
      <h1>Published Polls</h1>
    }
    @if (!hasDrafts) {
      <h1>Polls</h1>
    }
    <ng-container *ngTemplateOutlet="pollList; context: { polls: publishedPolls }"></ng-container>
  }

  @if (polls && polls.length > 0) {
    <tyt-pager [total]="total" [page]="page" [size]="pageSize" (changePage)="goToPage($event)"></tyt-pager>
  }

  <!-- POLL LIST TEMPLATE -->

  <ng-template #pollList let-polls="polls">
    @if (!polls) {
      <app-spinner></app-spinner>
    }
    @if (polls) {
      <div class="polls-list">
        @for (poll of polls; track poll) {
          <div class="poll">
            <div class="backdrop" [responsiveBackgroundImage]="poll.image" [widthFactor]="0.25" [mobileWidthFactor]="0.5">
              <div class="overlay"></div>
            </div>
            <div class="details-container">
              <div class="details">
                @if (poll.status === 'draft') {
                  <a class="title" routerLink="/polls/{{poll.slug}}/edit">
                    {{poll.title}}
                  </a>
                }
                @if (poll.status !== 'draft') {
                  <a class="title" routerLink="/polls/{{poll.slug}}">
                    {{poll.title}}
                  </a>
                }
                @if (poll.description) {
                  <p>
                    {{poll.description}}
                  </p>
                }
                <ul class="facts">
                  <li>{{humanizeType(poll.type)}}</li>
                  <li>{{humanizeStatusSingular(poll.status)}}</li>
                  @if (poll.author) {
                    <li>
                      @if (poll.author.staff) {
                        TYT Staff
                      }
                      @if (!poll.author.staff) {
                        {{poll.author.display_name}}
                      }
                    </li>
                  }
                  @if (isStaff) {
                    <li>
                      @if (poll.status !== 'draft') {
                        <a routerLink="/polls/{{poll.slug}}/edit">Edit</a> |
                      }
                      <a href="javascript:;" (click)="deletePoll(poll.id)">Delete</a>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (polls && polls.length == 0) {
      <div class="empty-state">
        <div class="details">
          <mat-icon>poll</mat-icon>
          <em>No polls to show.</em>
        </div>
      </div>
    }
  </ng-template>

</div>

<h2>Looking for older polls?</h2>

<a href="https://join.tyt.com/polls/" target="_blank">Click here</a> to view older polls from TYT.
